module.exports = __webpack_public_path__ + "static/media/concurrent.5b0066dd.svg";